// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-91819e118133496ce8d090ef2f9cfb92","button__box":"button__box-30ccb7ad7c5a3fb2b87e05d784e77d3b"};